// src/components/CreatePostModal.js
import React, { useState, useEffect, useRef } from 'react';
import { useAuthContext } from '../contexts/AuthContext';
import './CreatePostModal.css';

export default function CreatePostModal({ isOpen, onClose, onSuccess }) {
    const { API_URL } = useAuthContext();
    const [content, setContent] = useState('');
    const [posting, setPosting] = useState(false);
    const [error, setError] = useState(null);
    const textareaRef = useRef(null);

    useEffect(() => {
        if (isOpen && textareaRef.current) {
            textareaRef.current.focus();
        }
        if (!isOpen) {
            setContent('');
            setError(null);
        }
    }, [isOpen]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!content.trim()) return;

        setPosting(true);
        setError(null);

        try {
            const response = await fetch(`${API_URL}/api/posts`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    content: content.trim()
                }),
                credentials: 'include'
            });

            const data = await response.json();

            if (response.ok) {
                if (onSuccess) onSuccess(data.post);
                onClose();
            } else {
                setError(data.error || 'Failed to post');
            }
        } catch (err) {
            setError('Network error. Please try again.');
        } finally {
            setPosting(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
                <div className="modal-header">
                    <h3 className="modal-title">Create Post</h3>
                    <button className="modal-close" onClick={onClose}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="24" height="24">
                            <line x1="18" y1="6" x2="6" y2="18"></line>
                            <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg>
                    </button>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="modal-body">
                        <textarea
                            ref={textareaRef}
                            value={content}
                            onChange={(e) => setContent(e.target.value)}
                            placeholder="What's your hot take on running?"
                            maxLength={280}
                            disabled={posting}
                        />
                    </div>

                    <div className="modal-footer">
                        <span className={`char-count ${content.length > 250 ? 'warning' : ''}`}>
                            {content.length}/280
                        </span>
                        <button
                            type="button"
                            className="cancel-button"
                            onClick={onClose}
                            disabled={posting}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="post-button"
                            disabled={!content.trim() || posting}
                        >
                            {posting ? 'Posting...' : 'Post'}
                        </button>
                    </div>
                    {error && <div className="modal-error">{error}</div>}
                </form>
            </div>
        </div>
    );
}
